/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './diaglab-bill.reducer';

export const DiaglabBill = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const diaglabBillList = useAppSelector(state => state.diaglabBill.entities);
  const loading = useAppSelector(state => state.diaglabBill.loading);
  const totalItems = useAppSelector(state => state.diaglabBill.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="diaglab-bill-heading" data-cy="DiaglabBillHeading">
        <Translate contentKey="tinyMedicRestApp.diaglabBill.home.title">Diaglab Bills</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.diaglabBill.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/diaglab-bill/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.diaglabBill.home.createLabel">Create new Diaglab Bill</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.diaglabBill.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {diaglabBillList && diaglabBillList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('billNumber')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.billNumber">Bill Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billNumber')} />
                </th>
                <th className="hand" onClick={sort('billDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.billDate">Bill Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billDate')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('discount')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.discount">Discount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discount')} />
                </th>
                <th className="hand" onClick={sort('cgst')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.cgst">Cgst</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cgst')} />
                </th>
                <th className="hand" onClick={sort('sgst')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.sgst">Sgst</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sgst')} />
                </th>
                <th className="hand" onClick={sort('totalCost')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.totalCost">Total Cost</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('totalCost')} />
                </th>
                <th className="hand" onClick={sort('statusCode')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.statusCode">Status Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('statusCode')} />
                </th>
                <th className="hand" onClick={sort('patientType')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.patientType">Patient Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('patientType')} />
                </th>
                <th className="hand" onClick={sort('cancelledReason')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.cancelledReason">Cancelled Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cancelledReason')} />
                </th>
                <th className="hand" onClick={sort('discountType')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.discountType">Discount Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discountType')} />
                </th>
                <th className="hand" onClick={sort('discountRemark')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.discountRemark">Discount Remark</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discountRemark')} />
                </th>
                <th className="hand" onClick={sort('addedByType')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.addedByType">Added By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByType')} />
                </th>
                <th className="hand" onClick={sort('addedByID')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.addedByID">Added By ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByID')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByID')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.modifiedByID">Modified By ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByID')} />
                </th>
                <th className="hand" onClick={sort('referedByName')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.referedByName">Refered By Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referedByName')} />
                </th>
                <th className="hand" onClick={sort('referralComments')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.referralComments">Referral Comments</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referralComments')} />
                </th>
                <th className="hand" onClick={sort('multiplier')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.multiplier">Multiplier</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('multiplier')} />
                </th>
                <th className="hand" onClick={sort('roundOffVal')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.roundOffVal">Round Off Val</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('roundOffVal')} />
                </th>
                <th className="hand" onClick={sort('printed')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.printed">Printed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('printed')} />
                </th>
                <th className="hand" onClick={sort('printCount')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.printCount">Print Count</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('printCount')} />
                </th>
                <th className="hand" onClick={sort('voided')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.voided">Voided</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('voided')} />
                </th>
                <th className="hand" onClick={sort('voidedReason')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.voidedReason">Voided Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('voidedReason')} />
                </th>
                <th className="hand" onClick={sort('voidedDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.voidedDate">Voided Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('voidedDate')} />
                </th>
                <th className="hand" onClick={sort('appliedCategoryCode')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.appliedCategoryCode">Applied Category Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('appliedCategoryCode')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.admission">Admission</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.glucoUser">Gluco User</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.diagLab">Diag Lab</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.diaglabAssistant">Diaglab Assistant</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.prescription">Prescription</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.labPrescription">Lab Prescription</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.scheme">Scheme</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.patientCategory">Patient Category</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.accessEntry">Access Entry</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabBill.appliedCategory">Applied Category</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {diaglabBillList.map((diaglabBill, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/diaglab-bill/${diaglabBill.id}`} color="link" size="sm">
                      {diaglabBill.id}
                    </Button>
                  </td>
                  <td>{diaglabBill.billNumber}</td>
                  <td>{diaglabBill.billDate}</td>
                  <td>{diaglabBill.active ? 'true' : 'false'}</td>
                  <td>{diaglabBill.cursor}</td>
                  <td>{diaglabBill.lastupdated}</td>
                  <td>{diaglabBill.microSec}</td>
                  <td>{diaglabBill.timestampentry}</td>
                  <td>{diaglabBill.discount}</td>
                  <td>{diaglabBill.cgst}</td>
                  <td>{diaglabBill.sgst}</td>
                  <td>{diaglabBill.totalCost}</td>
                  <td>{diaglabBill.statusCode}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PatientType.${diaglabBill.patientType}`} />
                  </td>
                  <td>{diaglabBill.cancelledReason}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.DiscountType.${diaglabBill.discountType}`} />
                  </td>
                  <td>{diaglabBill.discountRemark}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${diaglabBill.addedByType}`} />
                  </td>
                  <td>{diaglabBill.addedByID}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${diaglabBill.modifiedByType}`} />
                  </td>
                  <td>{diaglabBill.modifiedByID}</td>
                  <td>{diaglabBill.referedByName}</td>
                  <td>{diaglabBill.referralComments}</td>
                  <td>{diaglabBill.multiplier}</td>
                  <td>{diaglabBill.roundOffVal}</td>
                  <td>{diaglabBill.printed ? 'true' : 'false'}</td>
                  <td>{diaglabBill.printCount}</td>
                  <td>{diaglabBill.voided ? 'true' : 'false'}</td>
                  <td>{diaglabBill.voidedReason}</td>
                  <td>{diaglabBill.voidedDate}</td>
                  <td>{diaglabBill.appliedCategoryCode}</td>
                  <td>
                    {diaglabBill.admission ? <Link to={`/admission/${diaglabBill.admission.id}`}>{diaglabBill.admission.id}</Link> : ''}
                  </td>
                  <td>
                    {diaglabBill.glucoUser ? <Link to={`/gluco-user/${diaglabBill.glucoUser.id}`}>{diaglabBill.glucoUser.id}</Link> : ''}
                  </td>
                  <td>{diaglabBill.diagLab ? <Link to={`/diag-lab/${diaglabBill.diagLab.id}`}>{diaglabBill.diagLab.id}</Link> : ''}</td>
                  <td>
                    {diaglabBill.diaglabAssistant ? (
                      <Link to={`/diaglab-assistant/${diaglabBill.diaglabAssistant.id}`}>{diaglabBill.diaglabAssistant.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {diaglabBill.prescription ? (
                      <Link to={`/prescription/${diaglabBill.prescription.id}`}>{diaglabBill.prescription.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {diaglabBill.labPrescription ? (
                      <Link to={`/lab-prescription/${diaglabBill.labPrescription.id}`}>{diaglabBill.labPrescription.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{diaglabBill.scheme ? <Link to={`/payment-scheme/${diaglabBill.scheme.id}`}>{diaglabBill.scheme.id}</Link> : ''}</td>
                  <td>
                    {diaglabBill.patientCategory ? (
                      <Link to={`/patient-category/${diaglabBill.patientCategory.id}`}>{diaglabBill.patientCategory.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {diaglabBill.accessEntry ? (
                      <Link to={`/clinical-dictionary/${diaglabBill.accessEntry.id}`}>{diaglabBill.accessEntry.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {diaglabBill.appliedCategory ? (
                      <Link to={`/hospital-patient-attribute/${diaglabBill.appliedCategory.id}`}>{diaglabBill.appliedCategory.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/diaglab-bill/${diaglabBill.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/diaglab-bill/${diaglabBill.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/diaglab-bill/${diaglabBill.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.diaglabBill.home.notFound">No Diaglab Bills found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={diaglabBillList && diaglabBillList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DiaglabBill;
